import { bl_cms_post_view_hdr_RowClass } from '../../dbschema/bl_cms_post_view_hdr.model';
import { BaseContainerModel } from '../base-container.model';

export class PostViewContainerModel extends BaseContainerModel {
  bl_cms_post_view_hdr: bl_cms_post_view_hdr_RowClass = new bl_cms_post_view_hdr_RowClass();
}
